import {Button, Spin} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {
    GroupCompanyProtocolTabService
} from 'pages/ais/organization-structure-v5/services/group-company-protocol-tab.service';

import {IGroupCompanyProtocolForm} from '../../../model/types';
import {GroupCompanyProtocolForm} from './group-company-protocol-form';

export const GroupCompanyProtocolModal = ({value, fields}: IGroupCompanyProtocolForm) => {
    const [form] = useForm();
    const [isDataLoading, setIsDataLoading] = useState<boolean>( false);

    const onShow = async () => {
        const {data} = await GroupCompanyProtocolTabService.getById(value);
        form.setFieldsValue({
            id: data.id,
            inn: data.inn,
            requestId: data.requestId,
            requestDate: data.requestDate,
            reportingDate: data.reportingDate,
            companyGroupProtoGroupInfoDtos: data.companyGroupProtoGroupInfoDtos,
        });

        setIsDataLoading(false);
    };

    return (
        <ModalOpenerComponent
            component={<Button type="link">{fields.requestId}</Button>}
            controlsStyle={{marginTop: '20px'}}
            modalProps={{title: 'Протокол обработки сведений по структуре группы компаний'}}
            hideControls={{save: true}}
            controlLabels={{cancel: 'Закрыть'}}
            handleSave={(setIsModalOpen) => {
                setIsModalOpen(false);
            }}
            onShow={onShow}
            shouldConfirm={() => false}
            handleCancel={(setIsModalOpen) => {
                setIsModalOpen(false);
            }}
        >
            <Spin
                spinning={isDataLoading}
                tip="Загрузка информации о записи..."
            >
                <GroupCompanyProtocolForm
                    fields={fields}
                    formInstance={form}
                    value={value}
                />
            </Spin>
        </ModalOpenerComponent>
    );
};